import { financeI18nTr } from './finance-i18n';
// Türkiye
import { caseI18nTr } from './case-i18n';

export const locale = {
  lang: 'tr',
  data: {
    ...financeI18nTr,
    ...caseI18nTr,
    SPLASH: {
      LOADING: 'Yükleniyor...',
    },
    PWA: {
      UPDATE_TITLE: 'Yeni Güncelleme',
      UPDATE_TEXT: 'Uygulamanın yeni bir sürümü mevcut. Güncellemek ister misiniz?',
      UPDATE_CONFIRM: 'Güncelle',
      UPDATE_CANCEL: 'Daha Sonra',
    },
    CONNECTION: {
      OFFLINE: 'İnternet bağlantısı yok',
      SERVICE_UNREACHABLE: 'Uygulama sunucusuna ulaşılamıyor',
    },
    ERRORS: {
      GENERIC: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
      NETWORK: 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.',
      BAD_REQUEST: 'İstek geçersiz. Lütfen bilgileri kontrol edip tekrar deneyin.',
      UNAUTHORIZED: 'Oturumunuzun süresi dolmuş. Lütfen tekrar giriş yapın.',
      FORBIDDEN: 'Bu işlem için yetkiniz bulunmuyor.',
      NOT_FOUND: 'Aradığınız kayıt bulunamadı.',
      CONFLICT: 'Bu işlem mevcut bir kayıtla çakışıyor.',
      VALIDATION: 'Girilen bilgilerde hata var. Lütfen kontrol edin.',
      TOO_MANY_REQUESTS: 'Çok fazla istek gönderildi. Lütfen biraz bekleyin.',
      SERVER: 'Sunucu kaynaklı bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
      EMAIL_IN_USE: 'Bu e-posta adresi zaten kullanılıyor.',
      INVALID_CREDENTIALS: 'E-posta veya parola hatalı.',
      USER_NOT_ACTIVE: 'Kullanıcı hesabı aktif değil.',
      USER_NOT_ALLOWED: 'Kullanıcı hesabının giriş yapmasına izin verilmiyor.',
    },
    HTTP_ERROR_TOAST: {
      TITLE: 'Hata ile karşılaşıldı',
      COPY: 'Kopyala',
      COPY_ALL: 'Tümünü Kopyala ({{count}})',
      COPIED_SUCCESSFULLY: 'Başarıyla kopyalandı',
      ATTEMPT_COUNT: '{{count}} deneme kaydedildi',
      DISMISS: 'Hatayı kapat',
      DISMISS_ALL: 'Tüm hataları kapat',
    },
    ERROR_PAGE: {
      PAGE_404_TITLE: 'Hay aksi!',
      PAGE_404_MESSAGE: 'Aradığınız sayfa bulunamadı.',
      PAGE_500_TITLE: 'Sistem Hatası',
      PAGE_500_MESSAGE: 'Bir şeyler ters gitti! Lütfen daha sonra tekrar deneyin.',
      RETURN_HOME: 'Ana Sayfaya Dön',
    },
    NOTIFICATIONS: {
      TITLE: 'Bildirimler',
      EMPTY: 'Henüz bildirim yok.',
      MARK_ALL_READ: 'Tümünü okundu işaretle',
      CLEAR_ALL: 'Tümünü temizle',
      MARK_READ: 'Okundu işaretle',
      DELETE: 'Sil',
      ACTIONS: 'İşlemler',
      CLEAR_ALL_CONFIRM_TITLE: 'Tüm bildirimler temizlensin mi?',
      CLEAR_ALL_CONFIRM_MESSAGE: 'Gelen kutunuzdaki tüm bildirimler kalıcı olarak kaldırılacak.',
      PAGE_SUBTITLE: 'Bildirimlerinizi görüntüleyin ve yönetin',
      TEMPLATES: {
        WORK_COMPLETED: {
          TITLE: 'İş tamamlandı',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) için {{work}} işi tamamlandı.',
        },
        WORK_ASSIGNED_TO_UNIT: {
          TITLE: 'Birime iş atandı',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) için {{work}} işi {{workshop}} birimine atandı.',
        },
        TECHNICIAN_ASSIGNED: {
          TITLE: 'Size iş atandı',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) dosyasındaki {{work}} işi size atandı.',
        },
        CASE_STATUS_CHANGED: {
          TITLE: 'Dosya durumu güncellendi',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) dosyasının durumu {{previousStatus}} → {{newStatus}} olarak değişti.',
        },
        CASE_CHAT_MESSAGE: {
          TITLE_WITH_PLATE: '{{plate}} plakalı araç dosyasında yeni mesaj',
          TITLE_WITH_CASE: '{{caseNo}} dosyasında yeni mesaj',
          BODY: '{{senderName}}: {{messagePreview}}',
        },
        VEHICLE_REGISTERED: {
          TITLE: 'Yeni araç kaydı',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) kaydedildi, hasar analizi bekliyor.',
        },
        DAMAGE_INFORMATION_COMPLETED: {
          TITLE: 'Hasar bilgisi girildi',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) için hasar analizi tamamlandı, onayınız bekleniyor.',
        },
        SERVICE_MANAGER_APPROVED: {
          TITLE: 'Servis onayı verildi',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) servis müdürü tarafından onaylandı.',
        },
        PART_TRACKING_REQUIRED: {
          TITLE: 'Parça takibi gerekli',
          BODY: '{{plate}} plakalı araçta ({{caseNo}}) {{partCount}} parça için takip gerekiyor.',
        },
        DAMAGE_ANALYSIS_RETURNED: {
          TITLE: 'Hasar analizi geri gönderildi',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) için hasar analizi servis yöneticisi tarafından geri gönderildi.',
        },
        SERVICE_REVIEW_SENT: {
          TITLE: 'Servis kontrolü bekliyor',
          BODY: '{{plate}} plakalı araç ({{caseNo}}) atölye kontrolünü tamamladı, servis şefi onayı bekliyor.',
        },
        BOOKING_RECEIVED: { TITLE: 'Yeni randevu kaydı', BODY: '{{bookingSource}} randevusu {{plate}} için alındı.' },
        ARRIVAL_APPOINTMENT_SCHEDULED: { TITLE: 'Geliş randevusu planlandı', BODY: '{{plate}} için geliş randevusu {{appointmentDateTime}} olarak planlandı.' },
        DELIVERY_APPOINTMENT_SCHEDULED: { TITLE: 'Teslim randevusu planlandı', BODY: '{{appointmentIdentity}} teslimi {{appointmentDateTime}} olarak planlandı.' },
        APPOINTMENT_REMINDER: { TITLE: 'Randevu hatırlatması', BODY: '{{appointmentIdentity}} randevusu {{appointmentDateTime}} tarihinde.' },
        REPEAT_WORK_STATUS_CHANGED: { TITLE: 'İş tekrarı güncellendi', BODY: '{{plate}} için Tekrar İş #{{repeatSequence}} güncellendi.' },
        REPEAT_DELIVERY_READY: { TITLE: 'İş tekrarı teslime hazır', BODY: '{{plate}} için Tekrar İş #{{repeatSequence}} teslime hazır.' },
        REPEAT_DELIVERED: { TITLE: 'İş tekrarı teslim edildi', BODY: '{{plate}} için Tekrar İş #{{repeatSequence}} teslim edildi.' },
        INVOICE_ISSUED: { TITLE: 'Fatura kesildi', BODY: '{{plate}} ({{caseNo}}) için fatura kesildi olarak işaretlendi.' },
        INVOICE_UNISSUED: { TITLE: 'Fatura kesilmedi', BODY: '{{plate}} ({{caseNo}}) için fatura kesilmedi olarak işaretlendi.' },
        INVOICE_COLLECTED: { TITLE: 'Fatura tahsil edildi', BODY: '{{plate}} ({{caseNo}}) için fatura tahsil edildi olarak işaretlendi.' },
        INVOICE_COLLECTION_REVERTED: { TITLE: 'Fatura tahsilatı kaldırıldı', BODY: '{{plate}} ({{caseNo}}) için fatura tahsil edildi işareti kaldırıldı.' },
        CASE_DELETION_REQUESTED: { TITLE: 'Dosya silme talebi', BODY: '{{requesterName}}, {{plate}} plakalı araç ({{caseNo}}) için {{target}} silme talebi oluşturdu.' },
      },
    },
    MENU: {
      DASHBOARD: 'Servis Durum Paneli',
      USERS: 'Kullanıcılar',
      CASE: 'Servisteki Araçlar',
      CALENDAR: 'Randevulu Araçlar',
      WORKLIST: 'Atölye Takibi',
      SELF_BOOKING: 'Randevular',
      CUSTOMERS: 'Müşteri Listesi',
      FOLLOWED_CASES: 'Takipteki Dosyalar',
      ACCOUNTING: 'Muhasebe',
      ROLE_MANAGEMENT: 'Rol Yönetimi',
      NOTIFICATIONS: 'Bildirimler',
    },
    ROLE_MANAGEMENT: {
      TITLE: 'Rol Yönetimi', SUBTITLE: 'Her rol için kullanılabilir izinleri seçin.', ROLE: 'Rol',
      ADMIN_LOCKED: 'Admin her zaman tam yetkilidir ve düzenlenemez.', SAVE: 'İzinleri Kaydet', SAVING: 'Kaydediliyor...',
      SAVED: 'İzinler kaydedildi.', LOADING: 'İzinler yükleniyor...', LOAD_ERROR: 'İzinler yüklenemedi.',
      SAVE_ERROR: 'İzinler kaydedilemedi.', PERMISSIONS: 'izin',
      MODULES: { 'page-access': 'Sayfa Erişimleri', dashboard: 'Panel', identity: 'Kimlik', cases: 'Dosya Yönetimi', worklist: 'İş Listesi', calendar: 'Takvim', 'customer-bookings': 'Müşteri Randevuları', customers: 'Müşteriler', accounting: 'Muhasebe', performance: 'Performans' },
      FEATURES: { pages: 'Sayfalar', overview: 'Genel Bakış', roles: 'Roller', users: 'Kullanıcılar', listing: 'Dosya Listesi', 'deletion-requests': 'Silme Talepleri', 'damage-analysis': 'İş Emri Yönetimi', documents: 'Dokümanlar', billing: 'Fatura', delivery: 'Teslimat', 'time-management': 'Zaman Yönetimi', 'work-orders': 'İş Emirleri', calendar: 'Takvim', bookings: 'Randevular', profiles: 'Profiller', reports: 'Raporlar', tracking: 'Takip' },
      PERMISSION_DESCRIPTIONS: {
        DASHBOARD_VIEW: 'Panelde araç ve randevu sayılarını, yaklaşan randevuları, son dosya hareketlerini, dosya durum dağılımını ve atölye takibi özetini görüntüler.',
        USERS_VIEW: 'Kullanıcılar sayfasını açar; hesapları, atanmış rolleri, iletişim bilgilerini, hesap durumunu ve çalışma bilgilerini görüntüler. Düzenleme ve parola sıfırlama için Kullanıcıları yönet izni gerekir.',
        USERS_MANAGE: 'Kullanıcı oluşturur ve siler; kişisel/iletişim bilgilerini, rolünü, aktiflik durumunu ve işe giriş/çıkış tarihlerini düzenler; başka bir kullanıcının parolasını sıfırlar. Kullanıcılar sayfası için Kullanıcıları görüntüle izni de gerekir. Rol izinlerini değiştirme yalnızca Admin yetkisidir.',
        CASES_VIEW: 'Dosya listesini, Takipteki Dosyalar ve Atölye Takibi sayfalarını, dosya detaylarını ve İş Emirleri sekmesini açar; dosya listesi raporunu indirir. Ekspertiz, doküman, fatura ve teslimat sekmelerinin görüntüleme izinleri ayrıdır.',
        CASES_MANAGE: 'Müşteri randevusundan da dosya açabilir; kayıt, müşteri, araç, sigorta/poliçe ve Hasar & Sigorta bilgilerini düzenler. Teslimattan önce ihbar ve hasar tarihi/saati, yeri, nedeni ve tahmini tutarı da düzenler. Kayıt sırasında belgelerden otomatik doldurmayı kullanır. İş emri fiyatlandırma veya dosya silme yetkisi vermez.',
        CASE_DELETE: 'Dosya listesinden doğrudan dosya siler ve teslim randevusunun saatini boşaltır. Kayıt silinmiş olarak işaretlenir; veritabanında tutulur. Bekleyen silme talebi varsa önce sonuçlandırılması gerekir.',
        CASE_DELETION_REQUEST_CREATE: 'Admin olmayan kullanıcılar dosya silme veya tekrar iş emri iptal talebi oluşturabilir; yalnızca kendi bekleyen taleplerini geri çekebilir. Talep oluşturmak dosyayı silmez veya işi iptal etmez.',
        CASE_DELETION_REQUEST_REVIEW: 'Bekleyen dosya silme veya tekrar iş iptal taleplerini inceler ve reddeder. Dosya silmeyi onaylamak ayrıca Dosya sil iznini; tekrar iş iptalini onaylamak Admin yetkisini gerektirir.',
        DAMAGE_VIEW: 'Ekspertiz sekmesinde hasar haritasını, kayıtlı hasarları, atölyeleri, iş emri açıklamalarını, notları ve yedek parça adetlerini görüntüler. Analiz alanının açılması için gerekli araç geliş fotoğrafları tamamlanmalıdır.',
        DAMAGE_MANAGE: 'Gerekli araç geliş fotoğraflarını yükler; hasar haritasını, ekspertiz iş emirlerini, parçaları ve adetlerini düzenler; ek iş emri ekler; uygun aşamada analizi onaylar veya onayı geri çeker. Hasar & Sigorta bilgileri Dosyaları yönet izniyle düzenlenir.',
        DOCUMENTS_VIEW: 'Dokümanlar ve Resmi Formlar sekmelerini açar; yüklenen belgeleri/fotoğrafları görüntüler, oluşturulan formları indirir ve tekil veya toplu iş emri belgelerini yazdırır.',
        DOCUMENTS_MANAGE: 'Dosya belgelerini/fotoğraflarını yükler ve siler; belgeleri kategorilere atar, ek belgeleri ve zorunlu belge gereksinimlerini düzenler; kayıt yazdırma önizlemesi oluşturur. Zorunlu belge gereksinimleri teslimattan önce düzenlenebilir.',
        BILLING_VIEW: 'Dosyanın Fatura sekmesinde iş emri işçilik fiyatlarını, yedek parça birim fiyatlarını, ek hizmetleri, indirimleri, KDV/düzeltmeleri, toplamları ve faturanın kesilip kesilmediğini görüntüler.',
        BILLING_MANAGE: 'Fatura sekmesinde işçilik ve parça fiyatlarını düzenler; hizmet ve tutar ekler/düzenler, indirim ve KDV/düzeltmeleri ayarlar, eski faturalamayı yeni yapıya dönüştürür, faturayı kesildi/kesilmedi işaretler. Fiyat düzenleme için faturalama kilitli olmamalıdır; sekmeyi açmak ayrıca Faturalamayı görüntüle izni gerektirir.',
        DELIVERY_VIEW: 'Dosya ve tekrar işlerin Teslimat sekmesini açar; teslime hazır olma durumunu, randevu bilgilerini, teslim belgelerini/fotoğraflarını ve imza bilgilerini görüntüler.',
        DELIVERY_MANAGE: 'Dosya ve tekrar işler için teslim randevusu oluşturur/değiştirir, teslim imzasını kaydeder ve hazır olma koşulları sağlandığında teslimatı tamamlar. Teslim fotoğrafları/belgeleri doküman izinleriyle yönetilir.',
        CASE_TIMESTAMPS_MANAGE: 'Zamanları Güncelle bölümünü açar; dosya kayıt, fatura kesim, teslim ve imza zamanlarını; dosya/iş emri durum hareketlerinin zamanlarını; iş emri oluşturma, ek iş onayı, teslim randevusu ve gerçekleşen teslim zamanlarını düzeltir.',
        WORK_ORDER_MANAGE: 'Teknisyen atar/atamayı kaldırır; parça, tedarik durumu ve notları düzenler; tamamlanan işi onaylar/reddeder ve atölye onayını geri çeker; ek işi onaylar/iptal eder, tekrar iş oluşturur. Teknisyen atanmış işleri teknisyen adına başlatabilir, duraklatabilir, sürdürebilir ve tamamlayabilir. Tekrar işi doğrudan iptal yalnızca Admin yetkisidir; ilk ekspertiz/ek iş oluşturma Hasar analizini yönet izni gerektirir.',
        CALENDAR_VIEW: 'Takvimi açar, geliş ve teslim randevularını görüntüler, teslim randevusu raporunu indirir. Müşteri randevusu oluşturma/değiştirme Randevuları yönet; dosya teslim randevusu planlama Teslimatı yönet izni gerektirir.',
        BOOKINGS_VIEW: 'Randevular sayfasını açar; müşteri taleplerini, iletişim ve araç bilgilerini, geliş randevusunu, açıklamayı ve ekli belgeleri görüntüler.',
        BOOKINGS_MANAGE: 'Manuel randevu oluşturur; müşteri/iletişim/araç bilgilerini ve ekli belgeleri düzenler; geliş randevusu planlar/değiştirir; randevu kaydını siler. Randevudan dosya açmak ayrıca Dosyaları yönet izni gerektirir.',
        CUSTOMERS_VIEW: 'Müşteri Listesi sayfasını açar; müşteri veya plakaya göre arar, kilometreyi, ziyaret sayısını ve son servis tarihini görür; kayıt, randevu, teslimat ve tekrar işlerden oluşan servis geçmişini inceler. Bağlantılı dosyayı açmak Dosyaları görüntüle izni gerektirir.',
        ACCOUNTING_VIEW: 'Muhasebe sayfasında dönemlere göre kesilmiş fatura gelirlerini, işçilik/parça/ek hizmet dağılımını ve tutarlara katkı sağlayan dosyaları inceler; muhasebe, işçilik, yedek parça ve ek hizmet raporlarını indirir.',
        ACCOUNTING_MANAGE: 'Şu anda ek bir düzenleme işlemi açmaz: Muhasebe sayfası yalnızca raporlama içerir. Dosyanın işçilik/parça fiyatları, hizmetleri, indirimleri ve fatura durumu Faturalamayı yönet izniyle düzenlenir.',
        PERFORMANCE_VIEW: 'Performans sayfasında çalışanların haftalık/aylık/yıllık tamamlanan ve aktif iş sayılarını ve ortalama tamamlama sürelerini karşılaştırır; atölye dağılımlarını ve çalışan hareketlerinin ayrıntılarını inceler.',
      },
    },
    PERMISSIONS: {
      DASHBOARD_VIEW: 'Paneli görüntüle', USERS_VIEW: 'Kullanıcıları görüntüle', USERS_MANAGE: 'Kullanıcıları yönet', CASES_VIEW: 'Dosyaları görüntüle', CASES_MANAGE: 'Dosyaları yönet', CASE_DELETE: 'Dosya sil', CASE_DELETION_REQUEST_CREATE: 'Dosya silme talebi oluştur', CASE_DELETION_REQUEST_REVIEW: 'Dosya silme taleplerini incele', DAMAGE_VIEW: 'Hasar analizini görüntüle', DAMAGE_MANAGE: 'Hasar analizini yönet', DOCUMENTS_VIEW: 'Dokümanları görüntüle', DOCUMENTS_MANAGE: 'Dokümanları yönet', BILLING_VIEW: 'Faturayı görüntüle', BILLING_MANAGE: 'Faturayı yönet', DELIVERY_VIEW: 'Teslimatı görüntüle', DELIVERY_MANAGE: 'Teslimatı yönet', CASE_TIMESTAMPS_MANAGE: 'Zamanları yönet', WORK_ORDER_MANAGE: 'İş emirlerini yönet', CALENDAR_VIEW: 'Takvimi görüntüle', BOOKINGS_VIEW: 'Randevuları görüntüle', BOOKINGS_MANAGE: 'Randevuları yönet', CUSTOMERS_VIEW: 'Müşterileri görüntüle', ACCOUNTING_VIEW: 'Muhasebeyi görüntüle', ACCOUNTING_MANAGE: 'Muhasebeyi yönet', PERFORMANCE_VIEW: 'Performansı görüntüle',
    },
    ACCOUNTING: {
      COLLECTIONS_MORE_ERROR: 'Daha fazla tahsilat kaydı yüklenemedi.',
      COLLECTIONS_LOAD_ERROR: 'Dönem tahsilatları yüklenemedi.',
      COLLECTIONS_LOADING: 'Tahsilatlar yükleniyor...',
      COLLECTIONS_CONTRIBUTORS_TITLE: 'Dönemde tahsilat yapılan dosyalar',
      TOTAL_COLLECTED: 'Toplam tahsil edilen',
      COLLECTIONS_BREAKDOWN_TITLE: 'Tahsilat dağılımı',
      COLLECTIONS_AXIS_LABEL: 'Seçili dönemde tahsil edilen tutarlar (TL)',
      COLLECTIONS_EMPTY: 'Seçili dönemde tahsilat bulunamadı.',
      COLLECTIONS_CHART_TITLE: 'Dönem tahsilatları',
      COLLECTIONS_SUBTITLE: 'Seçili dönemde yapılan tahsilatları, tahsilat tarihlerine göre inceleyin.',
      SYNC_FRESHNESS: "En eski veri senkronizasyonu:",
      SYNC_FAILURES: "{{count}} kayıt senkronize edilemedi. Tutarlar son başarılı senkronizasyona aittir.",

      TITLE: 'Muhasebe',
      SUBTITLE: 'Finansal performansı ve muhasebe belgelerini inceleyin.',
      LIFECYCLE_SELECTOR: 'Fatura yaşam döngüsü filtresi',
      LIFECYCLE_ALL: 'Tümü',
      LIFECYCLE_ISSUED: 'Geçmiş Fatura Kesildi',
      LIFECYCLE_COLLECTED: 'Tahsilatlar',
      PERIOD_SELECTOR: 'Muhasebe raporlama dönemi',
      PERIOD_YEAR: 'Yıl',
      PERIOD_MONTH: 'Ay',
      PERIOD_WEEK: 'Hafta',
      DATE_NAVIGATION: 'Tarih gezintisi',
      PREVIOUS_PERIOD: 'Önceki dönem',
      NEXT_PERIOD: 'Sonraki dönem',
      EXPORT_REPORT: 'Muhasebe Raporu Çıkart',
      EXPORT_DISABLED: 'Rapor dışa aktarma özelliği yakında kullanıma sunulacak.',
      REPORT_DOWNLOAD_ERROR: 'Muhasebe raporu indirilemedi. Lütfen tekrar deneyin.',
      LABOR_REPORT_DOWNLOAD_ERROR: 'İşçilik raporu indirilemedi. Lütfen tekrar deneyin.',
      PARTS_REPORT_DOWNLOAD_ERROR: 'Yedek parça raporu indirilemedi. Lütfen tekrar deneyin.',
      ADDITIONAL_SERVICES_REPORT_DOWNLOAD_ERROR: 'Ek hizmet raporu indirilemedi. Lütfen tekrar deneyin.',
      CHART_TITLE: 'Finansal Görünüm',
      CHART_SKELETON_LABEL: 'Finansal görünüm grafik önizlemesi',
      CHART_LOADING: 'Yükleniyor...',
      CHART_LOAD_ERROR: 'Nakit akışı verileri yüklenemedi.',
      CHART_EMPTY: 'Seçili filtre için fatura geliri bulunamadı.',
      CASH_FLOW_AXIS_LABEL: 'Seçili fatura yaşam döngüsünden brüt gelir',
      RETRY: 'Tekrar dene',
      BREAKDOWN_TITLE: 'Dağılım',
      BREAKDOWN_SKELETON_LABEL: 'Muhasebe dağılımı önizlemesi',
      BREAKDOWN_LOADING: 'Yükleniyor...',
      BREAKDOWN_LOAD_ERROR: 'Fatura dağılımı yüklenemedi.',
      BREAKDOWN_EMPTY: 'Bu dönem için faturalandırılmış tutar bulunamadı.',
      TOTAL_BILLED: 'Toplam faturalandırılan',
      LABOR_BILLED: 'İşçilik',
      SPARE_PARTS_BILLED: 'Yedek parça',
      ADDITIONAL_SERVICES_BILLED: 'Ek hizmetler',
      REVENUE_DISTRIBUTION: 'Gelir Dağılımı',
      REVENUE_DISTRIBUTION_LABEL: 'Gelir dağılımı: İşçilik {{labor}} (%{{laborShare}}), yedek parça {{parts}} (%{{partsShare}}), ek hizmetler {{services}} (%{{servicesShare}}).',
      REPORT_ACTIONS: 'Kategori rapor işlemleri',
      EXPORT_LABOR_REPORT: 'İşçilik Raporu Çıkart',
      EXPORT_PARTS_REPORT: 'Parça Raporu Çıkart',
      EXPORT_ADDITIONAL_SERVICES_REPORT: 'Ek Hizmet Raporu Çıkart',
      REPORT_DISABLED: 'Kategori rapor dışa aktarma özelliği yakında kullanıma sunulacak.',
      LABOR_REPORT_DISABLED: 'İşçilik raporunu çıkart. Kategori rapor dışa aktarma özelliği yakında kullanıma sunulacak.',
      PARTS_REPORT_DISABLED: 'Yedek parça raporunu çıkart. Kategori rapor dışa aktarma özelliği yakında kullanıma sunulacak.',
      ADDITIONAL_SERVICES_REPORT_DISABLED: 'Ek hizmetler raporunu çıkart. Kategori rapor dışa aktarma özelliği yakında kullanıma sunulacak.',
      DOCUMENTS_TITLE: 'Belgeler',
      DOCUMENTS_SKELETON_LABEL: 'Muhasebe belgeleri önizlemesi',
      CONTRIBUTORS_TITLE: 'Katkı sağlayan dosyalar',
      CONTRIBUTORS_LOADING: 'Yükleniyor...',
      CONTRIBUTORS_LOAD_ERROR: 'Katkı sağlayan dosyalar yüklenemedi.',
      CONTRIBUTORS_EMPTY: 'Bu döneme katkı sağlayan dosya bulunamadı.',
      CONTRIBUTORS_LOADING_MORE: 'Daha fazla yükleniyor...',
      CONTRIBUTORS_LOAD_MORE_ERROR: 'Daha fazla katkı sağlayan dosya yüklenemedi.',
      OPEN_CONTRIBUTING_CASE: 'Dosyayı aç',
      COLUMN_PLATE: 'Plaka',
      COLUMN_CUSTOMER: 'Müşteri',
      COLUMN_INVOICE_ISSUED_AT: 'Fatura tarihi',
      COLUMN_INVOICE_COLLECTION_PAYMENT_METHOD: 'Hesap / yöntem',
      COLUMN_STATUS: 'Durum',
      COLUMN_LABOR: 'İşçilik',
      COLUMN_SPARE_PARTS: 'Yedek parça',
      COLUMN_ADDITIONAL_SERVICES: 'Ek hizmetler',
      COLUMN_TOTAL_BILLED: 'Toplam faturalandırılan',
    },
    SIDEBAR: {
      COLLAPSE: 'Kenar çubuğunu daralt',
      EXPAND: 'Kenar çubuğunu genişlet',
    },
    PAGINATION: {
      LABEL: 'Sayfalama',
      ROWS_PER_PAGE: 'Sayfa başına',
      PREVIOUS: 'Önceki sayfa',
      NEXT: 'Sonraki sayfa',
    },
    CALENDAR: {
      INDICATOR_LEGEND_LABEL: 'Takvim gösterge açıklamaları',
      INDICATOR_DELIVERED: 'Teslim edildi',
      INDICATOR_MISSED: 'Gecikmiş teslim',
      INDICATOR_SCHEDULED: 'Planlı teslim',
      INDICATOR_ARRIVAL: 'Planlı geliş',
      INDICATOR_TODAY: 'Bugün',
      REPORT_DOWNLOAD: 'Rapor Çıkart',
      REPORT_DOWNLOADING: 'Rapor hazırlanıyor...',
      REPORT_DOWNLOAD_ERROR: 'Rapor indirilemedi. Lütfen tekrar deneyin.',
      SHOW_COMPLETED_APPOINTMENTS: 'Tamamlananları Göster',
      DELIVERY_APPOINTMENTS_LOADING_MORE: 'Daha fazla randevu yükleniyor...',
      DELIVERY_APPOINTMENTS_LOAD_MORE_ERROR: 'Daha fazla randevu yüklenemedi.',
      COLUMN_DELIVERY: 'Teslim tarihi',
      COLUMN_APPOINTMENT_TYPE: 'Randevu türü',
      COLUMN_APPOINTMENT_DATE: 'Randevu tarihi',
      RETRY: 'Tekrar dene',
      LIST_ALL_APPOINTMENTS: 'Tüm Randevuları Listele',
      ALL_APPOINTMENTS_TITLE: 'Tüm Randevular',
      ALL_APPOINTMENTS_EMPTY: 'Yaklaşan randevu bulunamadı.',
      DELIVERY_APPOINTMENTS_TITLE: 'Teslim Randevuları',
      DELIVERY_APPOINTMENTS_LOADING: 'Teslim randevuları yükleniyor...',
      DELIVERY_APPOINTMENTS_EMPTY: 'Yaklaşan teslim randevusu bulunamadı.',
      DELIVERY_APPOINTMENTS_LOAD_ERROR: 'Teslim randevuları yüklenemedi. Lütfen tekrar deneyin.',
      TITLE: 'Takvim',
      SUBTITLE: 'Geliş ve teslim randevularını planlayın ve takip edin.',
      CONTROLS_LABEL: 'Takvim kontrolleri',
      VIEW_SELECTOR: 'Takvim görünümü',
      VIEW_MONTH: 'Ay',
      VIEW_WEEK: 'Hafta',
      VIEW_DAY: 'Gün',
      PREVIOUS_PERIOD: 'Önceki dönem',
      NEXT_PERIOD: 'Sonraki dönem',
      MORE_APPOINTMENTS: 'Daha fazla randevu var',
      OUTSIDE_HOURS: 'Hizmet saatleri dışındaki randevular',
      PREVIOUS_YEAR: 'Önceki yıl',
      NEXT_YEAR: 'Sonraki yıl',
      DISPLAY_DELIVERED: 'Teslim edilenleri göster',
      SCHEDULE_NEW_DELIVERY: 'Yeni Teslim Randevusu',
      SCHEDULE_NEW_APPOINTMENT: 'Yeni Randevu Planla',
      CREATE_MANUAL_BOOKING: 'Yeni Müşteri Kaydet',
      MANUAL_BOOKING_TITLE: 'Manuel Müşteri Kaydı',
      MANUAL_BOOKING_EDIT_TITLE: 'Kaydı Düzenle',
      MANUAL_BOOKING_SUBTITLE: 'Müşteri bilgilerini, geliş randevusunu ve isteğe bağlı belgeleri girin.',
      MANUAL_BOOKING_FIRST_NAME: 'Ad',
      MANUAL_BOOKING_LAST_NAME: 'Soyad',
      MANUAL_BOOKING_DOCUMENTS: 'Belgeler',
      MANUAL_BOOKING_DOCUMENTS_OPTIONAL: 'Belge eklemek isteğe bağlıdır.',
      MANUAL_BOOKING_EXISTING_DOCUMENTS: 'Mevcut belgeler ({{count}})',
      MANUAL_BOOKING_NEW_DOCUMENTS: 'Yeni belgeler',
      MANUAL_BOOKING_ADD_DOCUMENTS: 'Belge Ekle',
      MANUAL_BOOKING_REMOVE_DOCUMENT: '{{name}} belgesini kaldır',
      MANUAL_BOOKING_UNDO_DOCUMENT_REMOVAL: 'Geri Al',
      MANUAL_BOOKING_DOCUMENT_PENDING_REMOVAL: 'Kaydedildiğinde kaldırılır',
      MANUAL_BOOKING_DOCUMENT_REMOVAL_ERROR: 'Belge değişiklikleri kaydedilemedi. Hiçbir belge kaldırılmadı.',
      MANUAL_BOOKING_DOCUMENT_COUNT_ERROR: 'En fazla {{count}} belge eklenebilir.',
      MANUAL_BOOKING_DOCUMENT_INVALID_ERROR: 'Seçilen belge türü veya boyutu geçerli değil.',
      MANUAL_BOOKING_DOCUMENT_TOTAL_SIZE_ERROR: 'Belgelerin toplam boyutu izin verilen sınırı aşıyor.',
      MANUAL_BOOKING_SAVE: 'Kaydı Oluştur',
      MANUAL_BOOKING_UPDATE: 'Değişiklikleri Kaydet',
      MANUAL_BOOKING_SAVE_ERROR: 'Manuel müşteri kaydı oluşturulamadı. Lütfen tekrar deneyin.',
      MANUAL_BOOKING_UPDATE_ERROR: 'Kayıt güncellenemedi. Lütfen tekrar deneyin.',
      MANUAL_BOOKING_REQUIRED_ERROR: 'Bu alan zorunludur.',
      MANUAL_BOOKING_EMAIL_ERROR: 'Geçerli bir e-posta adresi girin.',
      MANUAL_BOOKING_PHONE_ERROR: 'Geçerli bir telefon numarası girin.',
      MANUAL_BOOKING_INVALID_ERROR: 'Geçerli bir değer girin.',
      MANUAL_BOOKING_APPOINTMENT_PAIR_ERROR: 'Geliş tarihi ve saati birlikte seçilmeli veya ikisi de boş bırakılmalıdır.',
      CANCEL_SCHEDULING: 'Teslim randevusu planlamasını iptal et',
      SCHEDULING_INSTRUCTION: '{{plate}} için randevu günü seçin.',
      ARRIVAL_SCHEDULING_INSTRUCTION: '{{plate}} için geliş randevusu günü seçin.',
      APPOINTMENT_CANDIDATES_TITLE: 'Randevu seçin',
      APPOINTMENT_CANDIDATES_SUBTITLE: 'Teslim veya geliş randevusu için bir kayıt seçin.',
      DELIVERY_CANDIDATES_TITLE: 'Dosya seçin',
      DELIVERY_CANDIDATES_SUBTITLE: 'Teslim randevusu için teslim edilmemiş bir dosya seçin.',
      DELIVERY_CANDIDATES_SEARCH_LABEL: 'Araç plakası ara',
      DELIVERY_CANDIDATES_SEARCH_PLACEHOLDER: 'Araç plakasına göre ara',
      DELIVERY_CANDIDATES_LOADING: 'Dosyalar yükleniyor...',
      DELIVERY_CANDIDATES_EMPTY: 'Eşleşen teslim edilmemiş dosya bulunamadı.',
      DELIVERY_CANDIDATES_LOAD_ERROR: 'Dosyalar yüklenemedi. Lütfen tekrar deneyin.',
      DELIVERY_APPOINTMENT_TITLE: 'Teslim Randevusu Oluşturun',
      DELIVERY_APPOINTMENT_SELECTION_TITLE: '{{plate}} · {{customer}} için Teslim Randevusu Belirleyin',
      DELIVERY_APPOINTMENT_DATE: 'Teslim tarihi',
      DELIVERY_APPOINTMENT_TIME: 'Teslim saati',
      DELIVERY_APPOINTMENT_TIME_REQUIRED: 'Geçerli bir teslim saati girin.',
      DELIVERY_APPOINTMENT_SAVE_ERROR: 'Teslim randevusu kaydedilemedi. Lütfen tekrar deneyin.',
      REMOVE_APPOINTMENT: 'Randevu Tarihini Kaldır',
      APPOINTMENT_REMOVE_ERROR: 'Randevu tarihi kaldırılamadı. Lütfen tekrar deneyin.',
      APPOINTMENT_SLOT_UNAVAILABLE: 'Bu saat dolu. Lütfen başka bir saat seçin.',
      ARRIVAL_APPOINTMENT_TITLE: 'Geliş Randevusu Oluşturun',
      ARRIVAL_APPOINTMENT_DATE: 'Geliş tarihi',
      ARRIVAL_APPOINTMENT_TIME: 'Geliş saati',
      ARRIVAL_APPOINTMENT_TIME_REQUIRED: 'Geçerli bir geliş saati girin.',
      ARRIVAL_APPOINTMENT_SAVE_ERROR: 'Geliş randevusu kaydedilemedi. Lütfen tekrar deneyin.',
      COLUMN_STATUS: 'Durum',
      COLUMN_EXPECTED_DELIVERY: 'Teslim randevusu',
      COLUMN_EXPECTED_APPOINTMENT: 'Planlanan randevu',
      CANCEL: 'Vazgeç',
      CONFIRM: 'Onayla',
      LOADING: 'Takvim etkinlikleri yükleniyor...',
      LOAD_ERROR: 'Takvim etkinlikleri yüklenemedi. Lütfen tekrar deneyin.',
      DAY_EVENT_COUNT: '{{count}} randevu etkinliği',
      DAY_EVENTS_TITLE: 'Randevular',
      COLUMN_PLATE: 'Araç plakası',
      COLUMN_TIME: 'Saat',
      COLUMN_EVENT: 'Tür',
      EVENT_TYPE_1: 'Teslim randevusu',
      EVENT_TYPE_2: 'Geliş Randevusu',
      EVENT_TYPE_RECEIVED: 'Teslim Alındı',
      EVENT_TYPE_DELIVERED: 'Teslim Edildi',
      CLOSE: 'Kapat',
    },
    SELF_BOOKING: {
      ARRIVAL_APPOINTMENT_SELECTION_TITLE: '{{plate}} · {{customer}} için Geliş Randevusu Belirleyin',
      ARRIVAL_APPOINTMENT_CALENDAR_LABEL: 'Geliş randevusu için aylık takvim',
      REFRESH: 'Yenile',
      REFRESHING: 'Yenileniyor',
      FILTER: 'Filtrele',
      FILTER_APPLY: 'Uygula',
      FILTER_CLEAR: 'Temizle',
      FILTER_CANCEL: 'Vazgeç',
      FILTER_ALL: 'Tümü',
      FILTER_CUSTOMER_PLACEHOLDER: 'Ad soyada göre filtrele',
      FILTER_PHONE_PLACEHOLDER: 'Telefona göre filtrele',
      FILTER_PLATE_PLACEHOLDER: 'Plakaya göre filtrele',
      FILTER_EXPECTED_ARRIVAL_FROM: 'Beklenen geliş başlangıç',
      FILTER_EXPECTED_ARRIVAL_TO: 'Beklenen geliş bitiş',
      FILTER_SUBMITTED_FROM: 'Gönderim tarihi başlangıç',
      FILTER_SUBMITTED_TO: 'Gönderim tarihi bitiş',
      TITLE: 'Randevular',
      SUBTITLE: 'Tüm kanallardan gelen müşteri randevu taleplerini görüntüleyin.',
      TOTAL_RECORDS: '{{count}} kayıt',
      CARD_TITLE: 'Yeni Randevu',
      CARD_TITLE_WEB: 'Web Randevusu',
      CARD_TITLE_WHATSAPP: 'WhatsApp Randevusu',
      CARD_TITLE_MANUAL: 'Manuel Randevu',
      SOURCE: 'Kaynak',
      SOURCE_WEBSITE: 'Web Sitesi',
      SOURCE_WHATSAPP: 'WhatsApp',
      SOURCE_MANUAL: 'Manuel',
      SUBMITTED_DATE: 'Gönderim Tarihi',
      COLUMN_CUSTOMER: 'Müşteri',
      COLUMN_EXPECTED_ARRIVAL: 'Beklenen Geliş',
      COLUMN_DOCUMENTS: 'Belgeler',
      VIEW_RECORD: 'Randevu detayını görüntüle',
      DETAIL_TITLE: 'Randevu Detayı',
      CLOSE_DETAIL: 'Randevu detayını kapat',
      PREVIEW_DOCUMENT: 'Belge {{number}} önizlemesi',
      DOCUMENT_PREVIEW_PREVIOUS: 'Önceki randevu belgesini göster',
      DOCUMENT_PREVIEW_NEXT: 'Sonraki randevu belgesini göster',
      UNVIEWED_ALERT: 'Görüntülenmemiş randevular var',
      NEW_CARD_ALERT: 'Yeni randevu',
      NAME_SURNAME: 'Ad Soyad',
      TCKN: 'T.C. Kimlik Numarası',
      VEHICLE_PLATE: 'Plaka',
      PHONE: 'Telefon',
      EMAIL: 'E-posta',
      DESCRIPTION: 'Açıklama',
      DOCUMENTS: 'Belgeler ({{count}})',
      NOT_SPECIFIED: 'Belirtilmedi',
      SHOW_MORE: 'Devamını göster',
      SHOW_LESS: 'Daha az göster',
      NO_DOCUMENTS: 'Belge eklenmemiş',
      DOCUMENT_ALT: 'Müşteri belgesi {{number}}',
      LOADING: 'Kayıtlar yükleniyor...',
      LOAD_ERROR: 'Müşteri kayıtları yüklenemedi. Lütfen tekrar deneyin.',
      RETRY: 'Tekrar dene',
      EMPTY_STATE: 'Henüz yeni randevu bulunmuyor.',
      COMPLETE: 'Kaydı Tamamla',
      COMPLETE_ARIA: '{{customer}} kaydını tamamla',
      COMPLETE_TOOLTIP: 'Müşteri kaydını tamamla',
      EXPECTED_ARRIVAL_DATE: 'Beklenen geliş tarihi',
      EXPECTED_ARRIVAL_TIME: 'Beklenen geliş saati',
      EDIT_BOOKING: 'Kaydı Düzenle',
      SET_APPOINTMENT_DATE: 'Randevu Tarihi Belirle',
      UPDATE_APPOINTMENT_DATE: 'Randevu Tarihini Güncelle',
      APPOINTMENT_SAVE_ERROR: 'Randevu tarihi kaydedilemedi. Lütfen tekrar deneyin.',
      DELETE: 'Kaydı sil',
      DELETE_ARIA: '{{customer}} kaydını sil',
      DELETE_CONFIRM_TITLE: 'Müşteri kaydını sil',
      DELETE_CONFIRM_MESSAGE: '{{customer}} tarafından oluşturulan kaydı silmek istediğinize emin misiniz?',
      DELETE_CONFIRM_ACTION: 'Sil',
      DELETE_CANCEL: 'Vazgeç',
      DELETE_ERROR: 'Müşteri kaydı silinemedi. Lütfen tekrar deneyin.',
      PAGINATION_ARIA: 'Müşteri kayıtları sayfaları',
      PREVIOUS_PAGE: 'Önceki sayfa',
      NEXT_PAGE: 'Sonraki sayfa',
    },
    CUSTOMER_LIST: {
      TITLE: 'Müşteri Listesi',
      SUBTITLE: 'Müşteri ve araç bazında servis geçmişini görüntüleyin.',
      SEARCH_LABEL: 'Müşteri veya araç ara',
      CUSTOMER_SEARCH_LABEL: 'Müşteri adı',
      PLATE_SEARCH_LABEL: 'Araç plakası',
      COLUMN_CUSTOMER: 'Müşteri',
      COLUMN_PHONE: 'Telefon',
      COLUMN_PLATE: 'Plaka',
      COLUMN_VEHICLE_MODEL: 'Araç Modeli',
      COLUMN_MILEAGE: 'Kilometre',
      COLUMN_VISIT_COUNT: 'Ziyaret',
      COLUMN_LAST_SERVICE: 'Son Servis',
      LOADING: 'Müşteriler yükleniyor...',
      EMPTY: 'Müşteri aracı bulunamadı.',
      LOAD_ERROR: 'Müşteri kayıtları yüklenemedi. Lütfen tekrar deneyin.',
      RETRY: 'Tekrar dene',
      TIMELINE_TITLE: 'Servis Geçmişi',
      TIMELINE_CREATE_CASE: 'Yeni Kayıt Oluştur',
      TIMELINE_CLOSE: 'Servis geçmişini kapat',
      TIMELINE_LOADING: 'Servis geçmişi yükleniyor...',
      TIMELINE_ERROR: 'Servis geçmişi yüklenemedi.',
      TIMELINE_EMPTY: 'Bu araç için servis hareketi bulunamadı.',
      TIMELINE_GO_TO_CASE: 'Dosyaya Git',
      TIMELINE_CASE: 'Dosya',
      TIMELINE_WORK_ORDER: 'İş emri',
      TIMELINE_EVENT_ARRIVAL_APPOINTMENT: 'Geliş randevusu alındı',
      TIMELINE_EVENT_CASE_CREATED: 'Dosya oluşturuldu',
      TIMELINE_EVENT_VEHICLE_ARRIVAL: 'Araç giriş yaptı',
      TIMELINE_EVENT_CASE_DELIVERED: 'Araç teslim edildi',
      TIMELINE_EVENT_CASE_DELIVERY_APPOINTMENT: 'Teslim randevusu verildi',
      TIMELINE_EVENT_REPEAT_CREATED: 'Tekrar iş emri oluşturuldu',
      TIMELINE_EVENT_REPEAT_CANCELLED: 'Tekrar iş emri iptal edildi',
      TIMELINE_EVENT_REPEAT_DELIVERED: 'Tekrar iş emri teslim edildi',
      TIMELINE_EVENT_REPEAT_DELIVERY_APPOINTMENT: 'Tekrar iş emri teslim randevusu verildi',
    },
    USER_MENU: {
      CHANGE_PASSWORD: 'Şifre Değiştir',
      CHANGE_PASSWORD_DESCRIPTION: 'Yeni şifrenizi belirleyin.',
      NEW_PASSWORD: 'Yeni Şifre',
      NEW_PASSWORD_CONFIRM: 'Yeni Şifre (Tekrar)',
      PASSWORD_REQUIRED: 'Şifre zorunludur',
      PASSWORD_MIN_LENGTH: 'Şifre en az 8 karakter olmalıdır',
      PASSWORDS_MUST_MATCH: 'Şifreler eşleşmiyor',
      CANCEL: 'Vazgeç',
      SAVE_PASSWORD: 'Şifreyi Kaydet',
      PLEASE_WAIT: 'Lütfen bekleyin...',
      CLOSE: 'Kapat',
      PASSWORD_CHANGE_SUCCESS_TITLE: 'Başarılı!',
      PASSWORD_CHANGE_SUCCESS: 'Şifreniz başarıyla güncellendi.',
      LANGUAGE: 'Dil',
      SIGN_OUT: 'Çıkış Yap',
    },
    CRUD: {
      NO_RECORDS: 'Kayıt bulunamadı.',
      ACTIONS: 'İşlemler',
      DELETE_CONFIRM_TITLE: '{{userName}} kullanıcısını silmek istediğinize emin misiniz?',
      DELETE_CONFIRM_TEXT: 'Bu işlem geri alınamaz.',
      LOADING: 'Yükleniyor...',
      CONFIRM_DELETE: 'Sil',
      CANCEL: 'İptal',
    },
    SELECT: {
      SEARCH: 'Seçeneklerde ara',
      NO_RESULTS: 'Eşleşen seçenek yok',
    },
    DATE_PICKER: {
      FORMAT: 'gg/aa/yyyy',
    },
    APPOINTMENT_SLOT_PICKER: {
      SELECT_TIME: 'Saat seçiniz',
    },
    USER_LISTING: {
      SUBTITLE: 'Kullanıcı hesaplarını, rollerini ve erişim durumlarını yönetin.',
      FILTER: 'Filtrele',
      FILTER_APPLY: 'Uygula',
      FILTER_CLEAR: 'Temizle',
      FILTER_CANCEL: 'Vazgeç',
      FILTER_ALL: 'Tümü',
      FILTER_NAME_PLACEHOLDER: 'Ada göre filtrele',
      COLUMN_NAME_SORT: 'Ada göre sırala',
      COLUMN_START_DATE_SORT: 'İşe başlama tarihine göre sırala',
      COLUMN_END_DATE_SORT: 'İşten çıkış tarihine göre sırala',
      ADD_USER: 'Kullanıcı Ekle',
      COLUMN_NAME: 'Ad',
      COLUMN_ROLE: 'Rol',
      COLUMN_STATUS: 'Durum',
      COLUMN_START_DATE: 'İşe Başlama',
      COLUMN_END_DATE: 'İşten Çıkış',
      COLUMN_LAST_LOGIN: 'Son Giriş',
      USER_INFORMATION: 'Kullanıcı Bilgileri',
      FIRST_NAME: 'Ad',
      LAST_NAME: 'Soyad',
      FIRST_NAME_REQUIRED: 'Ad zorunludur',
      LAST_NAME_REQUIRED: 'Soyad zorunludur',
      NAME_MIN_LENGTH: 'Ad veya soyad en az 2 karakter olmalıdır',
      NAME_MAX_LENGTH: 'Ad veya soyad en fazla 128 karakter olmalıdır',
      NAME_INVALID_PATTERN: 'Ad veya soyad yalnızca harf, boşluk, tire, kesme işareti veya nokta içermelidir',
      EMAIL: 'E-posta',
      EMAIL_TOOLTIP: 'E-posta adresi aktif olmalıdır',
      EMAIL_REQUIRED: 'E-posta zorunludur',
      EMAIL_INVALID: 'E-posta geçerli değil',
      ROLE: 'Rol',
      ROLE_SELECT: 'Rol seçin',
      ROLE_REQUIRED: 'Rol zorunludur',
      PHONE: 'Telefon',
      PHONE_INVALID: 'Telefon zorunludur ve sadece rakam içermelidir',
      PHONE_MIN_LENGTH: 'Telefon en az 7 rakam olmalıdır',
      PHONE_MAX_LENGTH: 'Telefon en fazla 15 rakam olmalıdır',
      BIRTH_DATE: 'Doğum Tarihi',
      BIRTH_DATE_FUTURE: 'Doğum tarihi gelecekte olamaz',
      GENDER: 'Cinsiyet',
      GENDER_UNKNOWN: 'Belirtilmedi',
      GENDER_FEMALE: 'Kadın',
      GENDER_MALE: 'Erkek',
      GENDER_OTHER: 'Diğer',
      EMPLOYMENT_INFORMATION: 'Çalışan Bilgileri',
      START_DATE: 'İşe Başlama Tarihi',
      END_DATE: 'İşten Çıkış Tarihi',
      STATUS: 'Durum',
      STATUS_NEW_ACCOUNT: 'Yeni Hesap',
      STATUS_ACTIVE: 'Aktif',
      STATUS_PASSIVE: 'Pasif',
      STATUS_DELETED: 'Silindi',
      PASSWORD: 'Şifre',
      PASSWORD_REQUIRED: 'Şifre zorunludur',
      PASSWORD_MIN_LENGTH: 'Şifre en az 8 karakter olmalıdır',
      RESET_PASSWORD: 'Şifre Sıfırla',
      RESET_PASSWORD_FOR: '{{name}} için yeni şifre belirleyin',
      NEW_PASSWORD: 'Yeni Şifre',
      NEW_PASSWORD_CONFIRM: 'Yeni Şifre (Tekrar)',
      PASSWORDS_MUST_MATCH: 'Şifreler eşleşmiyor',
      PASSWORD_RESET_SUCCESS: 'Kullanıcı şifresi başarıyla güncellendi!',
      EDIT_USER: 'Kullanıcıyı Düzenle',
      DELETE_USER: 'Kullanıcıyı Sil',
      USER_DELETED: 'Kullanıcı başarıyla silindi!',
      EMPTY_STATE: 'Kullanıcı bulunamadı',
      LOAD_ERROR: 'Kullanıcılar yüklenemedi',
      DISCARD: 'Vazgeç',
      SUBMIT: 'Kaydet',
      PLEASE_WAIT: 'Lütfen bekleyin...',
      SUCCESS_TITLE: 'Başarılı!',
      USER_UPDATED: 'Kullanıcı başarıyla güncellendi!',
      USER_CREATED: 'Kullanıcı başarıyla oluşturuldu!',
      ERROR_TITLE: 'Hata!',
      CONFIRM_OK: 'Tamam',
    },
    SYSTEM_ROLES: {
      Admin: 'Yönetici',
      FrontDesk: 'Ön Büro',
      DamageAnalysis: 'Hasar Analizi',
      WorkshopManager: 'Atölye Yöneticisi',
      Accounting: 'Muhasebe',
      Bodywork: 'Kaporta',
      Mechanical: 'Mekanik',
      Electrical: 'Elektrik',
      Paint: 'Boya',
      Washing: 'Yıkama',
    },
    THEME: {
      LIGHT: 'Açık',
      DARK: 'Koyu',
      SYSTEM: 'Sistem',
    },
    WORKLIST_LISTING: {
      SUBTITLE: 'Atanan işleri ve bekleyen aksiyonları görüntüleyin.',
      COLUMN_CASE: 'Araç Plakası',
      COLUMN_VEHICLE_INFO: 'Araç bilgisi',
      COLUMN_RESPONSIBLE: 'Sorumlu',
      COLUMN_ACTION: 'Yapılacak işlem',
      COLUMN_UPDATED_DATE: 'Güncellenme tarihi',
      VIEW_RECORD: 'Kaydı aç',
      EMPTY_STATE: 'İş listesi kaydı bulunamadı',
      LOAD_ERROR: 'İş listesi yüklenemedi',
      ACTION_COMPLETE_DAMAGE_ANALYSIS: 'Hasar analizini tamamla',
      ACTION_UPDATE_PART_STATUS: 'Parça durumunu güncelle',
      ACTION_APPROVE_COMPLETED_WORK: 'Tamamlanan işleri onayla',
      ACTION_ROUTE_TO_WORKSHOPS: 'İşleri atölyelere yönlendir',
      ACTION_ASSIGN_TECHNICIAN: 'Usta ata',
      ACTION_START_WORK: 'İşe başla',
      ACTION_COMPLETE_WORK: 'İşi tamamla',
      ACTION_RESUME_WORK: 'İşe devam et',
      ACTION_COMPLETE_ACCOUNTING_CHECK: 'Muhasebe kontrolünü tamamla',
      ACTION_DELIVER_VEHICLE: 'Teslimi tamamla',
      ACTION_OPEN_CASE: 'Dosyayı aç',
      RESPONSIBLE_ROLE_DamageAnalysis: 'Hasar Analizi',
      RESPONSIBLE_ROLE_WorkshopManager: 'Atölye Şefi',
      RESPONSIBLE_ROLE_FrontDesk: 'Front Desk',
      RESPONSIBLE_ROLE_Accounting: 'Muhasebe',
      RESPONSIBLE_ROLE_UNKNOWN: '-',
    },
    FOLLOWED_CASES: {
      SUBTITLE: 'Takip ettiğiniz dosyalardaki son gelişmeleri görüntüleyin.',
      COLUMN_CASE: 'Araç Plakası',
      COLUMN_VEHICLE_INFO: 'Araç bilgisi',
      COLUMN_LAST_ACTIVITY: 'Son katılım',
      COLUMN_DATE: 'Tarih',
      VIEW_RECORD: 'Kaydı aç',
      EMPTY_STATE: 'Takip edilecek aktif dosya bulunamadı',
      LOAD_ERROR: 'Takip edilen dosyalar yüklenemedi',
      ACTIVITY_CASE_CREATED: {
        TITLE: 'Araç kaydedildi',
        DETAIL: 'Bu aracın kaydını siz oluşturdunuz.',
      },
      ACTIVITY_TECHNICIAN_ASSIGNED: {
        TITLE: 'İşe atandınız',
        DETAIL: '{{work}} işi size atandı.',
      },
    },
    PERFORMANCE_TRACKING: {
      TITLE: 'Performans Raporları',
      SUBTITLE: 'Ekip performansını ve iş tamamlama sürelerini inceleyin.',
      PERIOD_SELECTOR: 'Dönem seçici',
      PERIOD_WEEKLY: 'Bu Hafta',
      PERIOD_MONTHLY: 'Bu Ay',
      PERIOD_YEARLY: 'Bu Yıl',
      COLUMN_NAME: 'Ad Soyad',
      COLUMN_ROLE: 'Rol',
      COLUMN_COMPLETED: 'Tamamlanan',
      COLUMN_ACTIVE: 'Aktif İş',
      COLUMN_AVERAGE_TIME: 'Ort. Süre',
      TOTAL_COMPLETED: 'Toplam {{count}} tamamlanan iş',
      LOAD_ERROR: 'Performans verisi yüklenemedi',
      DETAIL_LOAD_ERROR: 'Kişi detayı yüklenemedi',
      EMPTY_STATE: 'Gösterilecek performans kaydı bulunamadı',
      LATEST_CASES: 'Son Çalışılan Dosyalar',
      EMPTY_EVENTS: 'Son aktivite bulunamadı',
      ACTIVITY_TIMELINE: 'Aktiviteler',
      NOT_AVAILABLE: '-',
      HOURS_FORMAT: '{{value}} sa',
      PLATE: 'Plaka',
      GO_TO_CASE: 'Dosyaya Git',
    },
    DASHBOARD: {
      PERFORMANCE_OVERVIEW: 'Performans Özeti',
      TOTAL_CASES: 'Toplam Dosya',
      CASE_STATUS_SUMMARY: 'Dosya durum özeti',
      SUMMARY_WIDGETS: 'Pano özeti',
      ARRIVAL_APPOINTMENTS: 'Geliş Randevusu',
      DELIVERY_APPOINTMENTS: 'Teslim Randevusu',
      WORKSHOP_VEHICLES: 'Servisteki Araç Sayısı',
      IN_REPAIR: 'Onarımda',
      DELIVERED_THIS_MONTH: 'Bu Ay Teslim Edilen',
      STATUS_GROUP_WAITING: 'Bekleyen',
      STATUS_GROUP_WAITING_DESCRIPTION: 'Fotoğraf, analiz, parça veya iş başlangıcı bekleniyor.',
      STATUS_GROUP_IN_PROGRESS: 'Devam Eden',
      STATUS_GROUP_IN_PROGRESS_DESCRIPTION: 'İşlemler aktif olarak devam ediyor.',
      STATUS_GROUP_DONE: 'Tamamlanan',
      STATUS_GROUP_DONE_DESCRIPTION: 'Teslime hazır veya teslim edildi.',
      REGISTERED: 'Kaydedildi',
      QUEUED_CASES: 'Sırada Bekleyen',
      IN_SERVICE: 'Serviste',
      READY_FOR_DELIVERY: 'Teslime Hazır',
      DELIVERED: 'Teslim Edildi',
      CASES_BY_STATUS: 'Dosya Durum Dağılımı',
      CASES_BY_STATUS_PERIOD: 'Dosya durum dönemi',
      PERIOD_WEEKLY: 'Haftalık',
      PERIOD_MONTHLY: 'Aylık',
      PERIOD_YEARLY: 'Yıllık',
      UPCOMING_APPOINTMENTS: 'Yaklaşan Randevular',
      OPEN_CALENDAR: 'Takvimi Aç',
      VIEW_ALL: 'Tümünü Gör',
      PLATE: 'Plaka',
      CUSTOMER: 'Müşteri',
      EVENT: 'Olay',
      USER: 'Kullanıcı',
      STATUS: 'Durum',
      EXPECTED_DELIVERY: 'Teslim Randevusu',
      APPOINTMENT_TIME: 'Randevu Zamanı',
      ARRIVAL_APPOINTMENT: 'Geliş Randevusu',
      DELIVERY_APPOINTMENT: 'Teslim Randevusu',
      LAST_UPDATE: 'Son Güncelleme',
      LOADING: 'Yükleniyor...',
      LOAD_ERROR: 'Pano verisi yüklenemedi',
      RETRY: 'Tekrar Dene',
      NO_DATA: 'Veri bulunamadı',
      STATUS_REGISTERED: 'Kaydedildi',
      STATUS_WAITING_IN_QUEUE: 'Sırada Bekliyor',
      STATUS_IN_SERVICE: 'Serviste',
      STATUS_READY_FOR_DELIVERY: 'Teslime Hazır',
      STATUS_DELIVERED: 'Teslim Edildi',
      TIME_JUST_NOW: 'az önce',
      TIME_MINUTES: '{{count}}d önce',
      TIME_HOURS: '{{count}}s önce',
      TIME_DAYS: '{{count}}g önce',
      LATEST_UPDATES: 'Son Gelişmeler',
    },
    AUTH: {
      BRAND: {
        SUBTITLE: 'OTOMOTO SİSTEMİ YÖNETİMİ',
      },
      ASIDE: {
        IMAGE_ALT: 'MOTO platform ekranları',
        TITLE: 'Operasyonu tek akışta yönetin',
        TEXT: 'Dosya, iş listesi ve ekip süreçlerini tek panelden takip edin. Günlük operasyon daha net, daha hızlı ve daha düzenli ilerlesin.',
      },
      LOGIN: {
        TITLE: 'Giriş Yap',
        SUBTITLE: 'MOTO hesabınızla devam edin',
        BUTTON: 'Oturum Aç',
        LOADING: 'Lütfen bekleyin...',
        SHOW_PASSWORD: 'Parolayı göster',
        HIDE_PASSWORD: 'Parolayı gizle',
      },
      INPUT: {
        EMAIL: 'E-posta',
        PASSWORD: 'Şifre',
      },
      VALIDATION: {
        INVALID: '{{name}} geçerli değil',
        REQUIRED: '{{name}} zorunludur',
        MIN_LENGTH: '{{name}} en az {{min}} karakter olmalıdır',
        MAX_LENGTH: '{{name}} en fazla {{max}} karakter olabilir',
        INVALID_LOGIN: 'Giriş bilgileri hatalı',
      },
    },
  },
};
